import { render, staticRenderFns } from "./PercepcionEmision.vue?vue&type=template&id=c64db1d0&scoped=true&"
import script from "./PercepcionEmision.vue?vue&type=script&lang=js&"
export * from "./PercepcionEmision.vue?vue&type=script&lang=js&"
import style0 from "./PercepcionEmision.vue?vue&type=style&index=0&id=c64db1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64db1d0",
  null
  
)

export default component.exports